<template>
<div class="">
    <index-list :selectionData="nowData"></index-list>
</div>
</template>
<script>
import indexList from '../components/index-list'
import Toast from '../components/toast/index'
import axios from 'axios';

export default {
    data() {
        return {
            nowData: [{
                    letter: 'A',
                    arr: ['阿拉木2', '阿拉蕾']
                },
                {
                    letter: 'B',
                    arr: ['布拉格', '不一定', '不发达', '不顾一切']
                },
                {
                    letter: 'C',
                    arr: ['草泥马', '草丛中', '超凡脱俗', '超人', '茶馆苏']
                },
                {
                    letter: 'D',
                    arr: ['大馒头', '大波波', '打飞机', '哒哒哒']
                },
                {
                    letter: 'E',
                    arr: ['饿了吗', '恩不打算', '恩尼个', '鹅鹅鹅']
                },
                {
                    letter: 'F',
                    arr: ['弗拉了', '符合', '房车']
                },
                {
                    letter: 'G',
                    arr: ['狗蛋', '狗剩', '公共', '光大']
                }
            ]
        }
    },
    components: {
        Toast,
        indexList
    },
    beforeRouteEnter(to, from, next) {
        document.title = ''
        next()
    },
    mounted() {
        // var city = remote_ip_info['city'];
        // alert(city)
    },
    methods: {
        nextRoute(index) {

        }
    }
}
</script>



// WEBPACK FOOTER //
// indexlist.vue?24666918